// extracted by mini-css-extract-plugin
export default {"container":"bp_d","invalidMessage":"bp_gg"};